"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var utils_1 = require("../../Input/utils");
var Loader_1 = __importDefault(require("../../Loader"));
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var AutosizeInput_1 = __importDefault(require("../components/AutosizeInput"));
var Label_1 = __importDefault(require("../components/Label"));
var InputValue_1 = __importDefault(require("./InputValue"));
var Wrapper = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex: 1 0 0;\n  border: 0;\n  font-size: ", ";\n  padding: 0 ", ";\n  ", "\n  min-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex: 1 0 0;\n  border: 0;\n  font-size: ", ";\n  padding: 0 ", ";\n  ",
    "\n  min-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.fontSize);
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.horizontalPadding);
}, function (_a) {
    var multiple = _a.multiple, disabled = _a.disabled;
    return !multiple &&
        disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-left: ", ";\n    "], ["\n      padding-left: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return polished_1.rem(theme.input.horizontalPadding);
    });
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.height);
}, function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (props) { return utils_1.getBorderFromProps(props); }, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.placeholderColor;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      -webkit-text-fill-color: ", ";\n      background-color: ", ";\n      cursor: ", ";\n    "], ["\n      -webkit-text-fill-color: ", ";\n      background-color: ", ";\n      cursor: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.input.disabledTextColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.input.disabledBackground;
    }, function (_a) {
        var theme = _a.theme;
        return theme.input.disabledCursor;
    });
});
var Values = styled_components_1.default('div')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", " 0;\n  margin-right: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  padding: ", " 0;\n  margin-right: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.select.padding);
});
var StyledInput = styled_components_1.default(AutosizeInput_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: none;\n  outline: none;\n  font-size: ", ";\n  background-color: ", ";\n"], ["\n  border: none;\n  outline: none;\n  font-size: ", ";\n  background-color: ", ";\n"])), polished_1.em(16), function (_a) {
    var theme = _a.theme;
    return theme.input.backgroundColor;
});
var ActionItem = styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0 ", ";\n  min-width: ", ";\n"], ["\n  padding: 0 ", ";\n  min-width: ", ";\n"])), polished_1.rem(4), polished_1.rem(24));
var InputLoader = styled_components_1.default(Loader_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ActionItem);
var IconBtn = styled_components_1.default('button')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0;\n  ", ";\n  ", "\n"], ["\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0;\n  ", ";\n  ",
    "\n"])), ActionItem, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      cursor: ", ";\n    "], ["\n      cursor: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.input.disabledCursor;
    });
});
var SingleValue = styled_components_1.default('div')(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.input.fontSize);
});
var TriangleBtn = styled_components_1.withTheme(function (props) {
    var disabled = props.disabled, theme = props.theme;
    return (React.createElement(IconBtn, __assign({ type: "button" }, props, { disabled: !!disabled }),
        React.createElement(Icon_1.default, { name: "triangle-down", color: disabled ? theme.input.disabledTextColor : theme.textColor })));
});
exports.default = React.forwardRef(function (props, ref) {
    var value = props.value, onChange = props.onChange, multiple = props.multiple, inputValue = props.inputValue, onChangeInput = props.onChangeInput, loading = props.loading, focused = props.focused, disabled = props.disabled, inputEl = props.inputEl, isTouchDevice = props.isTouchDevice, error = props.error, placeholder = props.placeholder, clearable = props.clearable, restProps = __rest(props, ["value", "onChange", "multiple", "inputValue", "onChangeInput", "loading", "focused", "disabled", "inputEl", "isTouchDevice", "error", "placeholder", "clearable"]);
    var noValue = Array.isArray(value) ? value.length === 0 : !value;
    var input = disabled ? null : (React.createElement(StyledInput, __assign({ "data-testid": "TheSelect-input", ref: ref, value: inputValue, onChange: onChangeInput, placeholder: noValue ? placeholder : '' }, restProps)));
    return (React.createElement(Wrapper, { "data-testid": "TheSelect-InputWrapper", disabled: !!disabled, focused: focused, readOnly: focused, error: !!error, multiple: !!multiple, onMouseDown: function (e) {
            e.preventDefault();
            if (!focused && inputEl && inputEl.current) {
                inputEl.current.focus();
            }
        } },
        React.createElement(Values, null,
            !multiple && input,
            Array.isArray(value)
                ? value.map(function (val) { return (React.createElement(InputValue_1.default, { key: val.value === null ? '$null' : val.value, value: val, disabled: !!disabled, onRemove: disabled || isTouchDevice
                        ? undefined
                        : function () {
                            onChange(value.filter(function (v) { return v.value !== val.value; }));
                        } })); })
                : !inputValue &&
                    value && (React.createElement(SingleValue, null,
                    React.createElement(Label_1.default, { label: value.label, icon: value.icon, labelSize: 14 }))),
            multiple && input),
        clearable && !disabled && !noValue && (React.createElement(IconBtn, { "data-testid": "TheSelect-IconRemove", onMouseDown: function (e) {
                e.stopPropagation();
            }, onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                onChange(multiple ? [] : null);
                onChangeInput('');
            } },
            React.createElement(Icon_1.default, { name: "close" }))),
        loading ? (React.createElement(InputLoader, null)) : (React.createElement(TriangleBtn, { disabled: !!disabled, tabIndex: -1 }))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
